import blairPic from "@/public/images/artists/blair.png";
import { Artist } from "@/types/types";

export const blair = {
  id: "206",
  name: "Blair",
  image: blairPic,
  description: `Blair's voice is airy and childlike, with a warm, balanced mid-range and a smooth, clear timbre.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fblair-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Kids", "Theatrical", "Airy", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 56,
        high: 70,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
